<script>
import { createClass, updateClass } from "../../api";

export default {
  name: "ClassForm",

  props: {
    editing: {
      type: Boolean,
      required: false,
      default: false,
    },
    classId: {
      type: Number,
      required: false,
      default: 0,
    },
    className: {
      type: String,
      required: false,
      default: "",
    },
    classDescription: {
      type: String,
      required: false,
      default: "",
    },
    classSize: {
      type: String,
      required: false,
      default: "",
    },
    buttonText: {
      type: String,
      required: false,
      default: "Create class",
    },
    isRedirectAfterCreated: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  emits: ["input", "close"],
  data() {
    return {
      error: "",
      name: "",
      description: "",
      size: "",
    };
  },
  mounted() {
    if (this.editing) {
      this.name = this.className;
      this.description = this.classDescription;
      this.size = this.classSize;
    }
  },
  methods: {
    async submitClass() {
      try {
        this.error = "";

        if (!this.name) {
          this.error = this.$t("classes.classNeedsName");
          return;
        }

        const classData = {
          name: this.name,
          description: this.description,
          size: this.size,
        };

        const { data } = this.editing
          ? await updateClass({ ...classData, classId: this.classId })
          : await createClass({ ...classData });

        if (this.isRedirectAfterCreated) {
          const redirectTo = this.$route.query.redirectTo || "/classes";
          const redirectToHasQuery = redirectTo.includes("?");
          this.$router.push(
            `${redirectTo}${redirectToHasQuery ? "&" : "?"}classId=${data.id}`
          );
        }

        this.$emit("input", data);

        this.$showToastSuccess(
          this.$t("classes.classSavedSuccessfully", {
            action: this.editing
              ? this.$t("classes.updated")
              : this.$t("classes.created"),
          }),
          { title: this.$t("common.success") }
        );
      } catch (error) {
        this.error = error.response?.data?.error;
      }
    },
  },
};
</script>

<template>
  <eg-b-row>
    <eg-b-col lg="10">
      <eg-b-alert v-if="error" variant="danger" class="mb-2" show>
        {{ error }}
      </eg-b-alert>
      <eg-b-form>
        <eg-b-form-group id="name-group" label-for="name-input">
          <template #label>
            {{ $t("classes.classNameLabel") }} <span class="red-text">*</span>
          </template>
          <eg-b-form-input
            id="name-input"
            v-model="name"
            :placeholder="$t('common.name')"
            type="text"
          ></eg-b-form-input>
        </eg-b-form-group>

        <eg-b-form-group
          id="description-group"
          :label="$t('common.description')"
          label-for="description-textarea"
        >
          <eg-b-form-textarea
            id="description-textarea"
            v-model="description"
            :placeholder="$t('common.description')"
            rows="3"
            max-rows="6"
          ></eg-b-form-textarea>
        </eg-b-form-group>

        <eg-b-form-group
          id="size-group"
          :label="$t('classes.numberOfStudents')"
          label-for="size-input"
        >
          <eg-b-form-input
            id="size-input"
            v-model="size"
            :placeholder="$t('classes.enterNumber')"
            type="text"
          ></eg-b-form-input>
        </eg-b-form-group>
      </eg-b-form>

      <div class="text-right mt-4">
        <eg-b-button
          class="mr-2"
          @click="
            $listeners['close'] ? $emit('close') : $router.push('/classes')
          "
        >
          {{ $t("common.cancel") }}
        </eg-b-button>
        <eg-b-button type="submit" variant="info" @click="submitClass">
          {{ buttonText }}
        </eg-b-button>
      </div>
    </eg-b-col>
  </eg-b-row>
</template>
